import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IServiceConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { setIsServiceConfigLoading } from '../store/configurations.actions'
import ValidationService from '../../validation/services/validation.services'

export function* setServiceConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IServiceConfigResponse = yield call([configurationsService, configurationsService.getServiceDoc])
    const { entity } = response
    if (entity && entity.length) {
      yield put(actions.setServiceConfig(entity[0]))
      ValidationService.initialize()
    }
    yield put(setIsServiceConfigLoading(false))
    ValidationService.initialSetTimeWithSeconds(entity[0]?.DISPLAY_SECONDS ? true : false)
  } catch (e) {
    yield put(setIsServiceConfigLoading(false))
    yield put(throwPcrException(`setServiceConfig() error: ${e}`))
  }
}
export function* setServiceConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setServiceConfig)
}
